export default __webpack_public_path__ + "static/33-f5ff30304ec1b6b92cfc92cc728c8e19.jpg";